import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// Redux
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// Config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult } from '../../../core/interfaces/bool-result';
import { CustomValidators } from '../../../core/ng/custom-validators';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Module components
import { User } from '../../../user/model/user';
import { UserService } from '../../service/user.service';
import { userConfig } from '../../../user/config/user.config';
import { menuWantProtectedRoute } from '../../../menu/store/actions';
import { NavigationService } from '../../../nav/service/navigation.service';
import { LoadingphaseService } from '../../../nav/service/loadingphase.service';

const enum SubView {
    HIDE = 0,
    SIGNIN = 1 << 1,  // 2
    // exceptions
    INTERNAL_ERROR = 1 << 11, // 2048
}

@Component({
    selector: 'app-signin-view',
    templateUrl: './signin-view.component.html',
    styleUrls: ['./signin-view.component.scss']
})
export class SignInViewComponent implements OnInit, OnDestroy {

    // error
    private _errMsgSupView1 = '';
    private _errMsgSubViewIntErr = '';
    // sub views
    private _subView = SubView.SIGNIN;
    // from groups
    private _formSubView1: FormGroup = null;

    // loading data
    public set _loadingPhase(value: boolean) {
        this._loadingphaseService.setLoadingphase(value, 'sign_in');
    }

    constructor(
        private _router: Router,
        private _userService: UserService,
        private _store: NgRedux<IAppState>,
        private _navigationService: NavigationService,
        private _messageSnackService: UiMessageSnackService,
        private _loadingphaseService: LoadingphaseService,
    ) { }

    public ngOnInit(): void {
        // Init Form
        this._formSubView1 = new FormGroup({
            account: new FormControl('', CustomValidators.requiredStringTrimmed),
            password: new FormControl('', CustomValidators.requiredStringTrimmed)
        });
    }
    public ngOnDestroy(): void {
    }

    // ----------------------------------------------------------------------------------------------
    // -- Localization
    // ----------------------------------------------------------------------------------------------

    // ----------------------------------------------------------------------------------------------
    // -- Error
    // ----------------------------------------------------------------------------------------------
    private showErrorMessage(msg: string): void {
        this._messageSnackService.showSnackError(msg);
    }

    // ----------------------------------------------------------------------------------------------
    // -- Visibility
    // ----------------------------------------------------------------------------------------------
    public showView(): boolean { return this._subView !== SubView.HIDE; }
    public showSubView1(): boolean { return this._subView === SubView.SIGNIN; }
    // exceptions
    public showSubViewIntErr(): boolean { return this._subView === SubView.INTERNAL_ERROR; }

    // ----------------------------------------------------------------------------------------------
    // -- View 1
    // ----------------------------------------------------------------------------------------------
    private onSubmitSubPage1(): void {
        this._loadingPhase = true;

        // -->>ASY1
        this._userService.signIn_email(
            this._formSubView1.value.account,
            this._formSubView1.value.password
        )
            .then(async (boolResultASY1: IBoolResult) => {
                if (!boolResultASY1.result) {
                    this._loadingPhase = false;

                    // signin rejected
                    this.showErrorMessage(boolResultASY1.message.message);
                    return;
                }
                await this._userService.getUserRoles();
                // -- ok - successfully signed in
                this._messageSnackService.showSnackSuccess('Anmeldung erfolgreich', 'NavigationContComponent');

                // -->>ASY3 - laden der Navigation config
                this._navigationService.loadNavigationConfig()
                    .then((boolResultASY3: IBoolResult) => {

                        this._loadingPhase = false;

                        if (!boolResultASY3.result) {
                            // signin rejected
                            this.showErrorMessage(boolResultASY3.message.message);
                            return;
                        }

                        // -->>ASY2 -- laden der backend version
                        this._userService.loadBackendVersion()
                            .then((boolResultASY2: IBoolResult) => {
                                this._loadingPhase = false;

                                // ignoriere Result Error

                                // activate route if user selected a menu button before
                                if (this._store.getState().menuState.wantProtectedRoute) {
                                    setTimeout(() => {
                                        this._router.navigate([this._store.getState().menuState.wantProtectedRoute]);
                                        this._store.dispatch(menuWantProtectedRoute(null));
                                    }, 400);
                                    return;
                                }

                                // default route
                                this._router.navigate(['/']);
                            })
                            .catch((err: ErrorMessage) => {
                                this._loadingPhase = false;
                                this._messageSnackService.showSnackError(err.message, 'NavigationContComponent');
                            });
                    })
                    .catch((err: ErrorMessage) => {
                        this._loadingPhase = false;
                        this._messageSnackService.showSnackError(err.message, 'NavigationContComponent');
                    });

            })
            .catch((err: ErrorMessage) => {
                this._loadingPhase = false;

                // show error message
                if (err.module === 'HttpErrorResponse') {
                    this.showErrorMessage(err.message);
                    return;
                }

                // internal error
                this._errMsgSubViewIntErr = err.message;
                this._subView = SubView.INTERNAL_ERROR;
            });
    }

    public onCancelSubPage1(): void {
        this._router.navigate(['/']);
    }

    private getAccountPlaceholder(): string {
        if (appConfig.dev.debugMode && appConfig.test.showTestCredentials) {
            return 'Benutzername' + ' (' + appConfig.test.account + ')';
        }
        return 'Benutzername';
    }

    private getPasswortPlaceholder(): string {
        if (appConfig.dev.debugMode && appConfig.test.showTestCredentials) {
            return 'Password' + ' (' + appConfig.test.passwort + ')';
        }
        return 'Password';
    }

    // ----------------------------------------------------------------------------------------------
    // -- View - Internal Error
    // ----------------------------------------------------------------------------------------------
    private onSubmitSubViewIntErr(): void {
        this._subView = SubView.SIGNIN;
    }
    private onCancelSubViewIntErr(): void {
        this._router.navigate(['/']);
    }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/compv/signin-view/signin-view.component.ts